export const openVideoSafari = () => {
  const videoPlayers = document.getElementsByClassName('rh5v-DefaultPlayer_video');
  Array.from(videoPlayers).map(p => p.pause());
};
